module.exports = __webpack_public_path__ + "img/sidebarUpArrow.f217f723.svg";